export const DEFAULT_PROFILE = {
  fullName: 'Award Commitee',
  email: 'award-commitee@sinarmas.com',
};
